var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4C12.0589 4 4 12.0589 4 22C4 31.9411 12.0589 40 22 40C31.9411 40 40 31.9411 40 22C40 12.0589 31.9411 4 22 4ZM0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22ZM20.4902 12.8661C20.5091 12.8782 20.5279 12.8903 20.5467 12.9024L29.9879 18.9718C30.0051 18.9828 30.0225 18.994 30.0399 19.0052C30.3421 19.1993 30.6722 19.4114 30.9352 19.6165C31.2142 19.8341 31.6545 20.2178 31.9142 20.8323C32.2296 21.5788 32.2296 22.4212 31.9142 23.1677C31.6545 23.7822 31.2142 24.1659 30.9352 24.3835C30.6722 24.5886 30.3421 24.8007 30.0399 24.9948C30.0225 25.006 30.0051 25.0172 29.9879 25.0282L20.5467 31.0976C20.5279 31.1097 20.5091 31.1218 20.4902 31.1339C20.1387 31.36 19.7692 31.5977 19.4438 31.7671C19.1164 31.9375 18.5222 32.2133 17.7863 32.1607C16.9183 32.0987 16.12 31.6629 15.5985 30.9663C15.1563 30.3756 15.067 29.7267 15.0333 29.3591C14.9998 28.9938 14.9999 28.5544 15 28.1365C15 28.1141 15 28.0917 15 28.0693V15.9307C15 15.9083 15 15.8859 15 15.8635C14.9999 15.4456 14.9998 15.0062 15.0333 14.6408C15.067 14.2733 15.1563 13.6244 15.5985 13.0337C16.12 12.3371 16.9183 11.9013 17.7863 11.8393C18.5222 11.7867 19.1164 12.0625 19.4438 12.2329C19.7692 12.4023 20.1388 12.64 20.4902 12.8661ZM19 16.6633V27.3367L27.3015 22L19 16.6633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOver);
export default __webpack_public_path__ + "static/media/videoOver.30a152e06490820a25ff67059e4f11b2.svg";
export { ForwardRef as ReactComponent };